import { toast } from "sonner";
import { createCheckoutSession } from "@/lib/api";
import { ANALYTICS_EVENTS, trackEvent } from "@/lib/analytics";

/**
 * Start Stripe Checkout via backend session (supports trial_period_days on monthly).
 * @param {string} planId weekly | monthly | annual
 * @param {{ jobId?: string }} [opts]
 */
export async function startPlanCheckout(planId, opts = {}) {
  const jobId = opts.jobId != null ? String(opts.jobId).trim() : "";
  try {
    const { url } = await createCheckoutSession(planId, jobId ? { jobId } : {});
    if (!url) {
      toast.error("Checkout could not be started.");
      return;
    }
    trackEvent(ANALYTICS_EVENTS.FUNNEL_CHECKOUT_START, {
      plan_id: planId,
      job_id: jobId || undefined,
    });
    window.location.assign(url);
  } catch (err) {
    const detail = err?.response?.data?.detail;
    const msg =
      typeof detail === "string"
        ? detail
        : "Unable to start checkout. Try again.";
    toast.error(msg);
    throw err;
  }
}
